import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #192619;
  padding-top: 20px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const Subcontainer = styled.div`
  flex: 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
`;

export const Title = styled.h1`
  color: #FFFFFF;
  font-size: 2rem;
  font-weight: bold;
  margin: 0;

  @media (max-width: 480px) {
    font-size: 1.75rem;
    text-align: center;
  }
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background-color: #E8FC8B;
  color: #1B2D1A;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;

  &:hover {
    background-color: rgba(232, 252, 139, 0.9);
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const SearchContainer = styled.div`
  margin-bottom: 2rem;
  position: relative;

  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  padding-left: 2.5rem;
  background-color: #2A3C29;
  border: 1px solid #3A4C39;
  border-radius: 0.5rem;
  color: #FFFFFF;
  font-size: 1rem;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #E8FC8B;
    background-color: #3A4C39;
  }

  &::placeholder {
    color: #FFFFFF80;
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #FFFFFF;
`;

export const AdministratorsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const AdministratorCard = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: #2A3C29;
  padding: 1.5rem;
  border-radius: 0.5rem;
  color: #FFFFFF;
  transition: all 0.2s;
  position: relative;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    background-color: #3A4C39;
  }

  @media (max-width: 480px) {
    padding: 1rem;
    gap: 0.75rem;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  min-width: 24px;
  
  @media (max-width: 480px) {
    min-width: 20px;
  }
`;

export const AdministratorEmail = styled.span`
  font-size: 1.1rem;
  font-weight: 500;
  flex: 1;
  margin-right: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 1rem;
    margin-right: 0.5rem;
  }
`;

export const CardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0.5rem;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 0.25rem;

  &:hover {
    color: #E8FC8B;
    background-color: rgba(232, 252, 139, 0.1);
  }

  @media (max-width: 480px) {
    padding: 0.375rem;
  }
`;

export const NoResults = styled.div`
  text-align: center;
  color: #FFFFFF;
  padding: 2rem;
  font-size: 1.1rem;
`; 